import { z } from 'zod';

export const VALIDATE_LOGIN_LINK_ERROR_CODE = {
  LOGIN_TOKEN_EXPIRED: 'LOGIN_TOKEN_EXPIRED',
  LOGIN_TOKEN_USED: 'LOGIN_TOKEN_USED',
  LOGIN_TOKEN_INVALID: 'LOGIN_TOKEN_INVALID',
} as const;

export const validateLoginLinkErrorCodeSchema = z.enum(VALIDATE_LOGIN_LINK_ERROR_CODE);
export type ValidateLoginLinkErrorCode = z.infer<typeof validateLoginLinkErrorCodeSchema>;
